import { BaseHospitalService, Hospital } from '@ianesthesie-kit/services';

export class HospitalService extends BaseHospitalService {
  private static readonly INSTANCE: HospitalService = new HospitalService();

  private constructor() {
    super('/hospital');
  }

  public static getInstance() {
    return this.INSTANCE;
  }

  protected transformResponseEntity(data: any): Hospital {
    return {
      ...super.transformResponseEntity(data),
      logo: data.logoMedium
    };
  }
}
